export function fetchWithTimeout(resource, options = {}, timeout) {
  const controller = new AbortController();
  const id = timeout && setTimeout(() => controller.abort(), timeout);

  return fetch(
    resource,
    {
      ...options,
      signal: controller.signal,
    },
  ).finally(() => {
    if (id) {
      clearTimeout(id);
    }
  });
}
